import api from './config/api';
import axios from './config/axios';

const getDefaultPrinter = async () => axios( {
    url: api.omniprintUrl( 'api/v1/omniprint/defaultPrinter' ),
    method: 'get',
} );

const getAvailablePrinters = async () => axios( {
    url: api.omniprintUrl( 'api/v1/omniprint/printers' ),
    method: 'get',
} );

const setDefaultPrinter = async ( printerName ) => axios( {
    url: api.omniprintUrl( 'api/v1/omniprint/defaultPrinter' ),
    method: 'put',
    params: { printerName },
} );

const printLabel = async ( labelUrl ) => axios( {
    url: api.omniprintUrl( 'api/v1/omniprint/printLabel' ),
    method: 'post',
    params: { labelUrl },
} );

// Using timeout to prevent long wait
const checkHealth = async () => axios( {
    url: api.omniprintUrl( 'api/v1/omniprint/healthCheck' ),
    method: 'get',
    timeout: 750,
} );

export default {
    getDefaultPrinter,
    checkHealth,
    getAvailablePrinters,
    printLabel,
    setDefaultPrinter,
};
